/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Typography, Badge, Box, LinearProgress } from '@mui/material';
import FxCard from '../../../Container/FxCard';
import FxCardHeader from '../../../Container/FxCardHeader';
import FxCardBody from '../../../Container/FxCardBody';
import { ReactComponent as Verified } from '../../../../assets/svg/verify-filled-icon.svg';
import { ReactComponent as NotVerified } from '../../../../assets/svg/red-x-line-icon.svg';
import { useMediaQuery } from 'react-responsive';
import FxCardFooter from '../../../Container/FxCardFooter';
import { ReactComponent as ShieldSignupLeftpanel } from '../../../../assets/svg/signup/shield-signup-leftpanel.svg';
import { getKey } from '../../../../libs/utils/storageManager';
import { checkMenuValid } from '../Common/CommonSignupClass';
import { FxStepper, IStep } from '../../../Input/FxStepper/FxStepper';
import { ReactComponent as Warning } from '../../../../assets/svg/pending.svg';
import { ReactComponent as ArrowIcon } from '../../../../assets/svg/stepper-arrow.svg'
import { SuccessIconWithClass } from '../Common/SuccessIconWithClass';
import { useIsMobileOrTabletScreen, useIsMobileScreen } from '../../../../libs/utils/utils';


/**
 * Component: SignUpLeftBar
 */

export const JointTenancySignUpLeftBar: React.FC<any> = React.memo((props) => {
  const isMobileScreen = useIsMobileScreen();
  const isSmallScreen = useIsMobileOrTabletScreen();
  let keys = ['jtIdentificationForm','jtCoOwnerForm']
  // menu options
  const options: any = [
    {
      title: "Tell us about yourself",
      action: "verify_yourself",
      subtitle:"We verify details to keep your Account secure and compliant.",
      order: 1
    }
  ];
  options.push({title: "Add Co-Owner",action: "add_a_co-owner", subtitle:"Add Co-Owner details facilitate shared Ownership and Management of funds.", order: 2 })
  options.push({title: "Review & Submit for Verification",action: "review_and_submit", subtitle:"Double-check your details and submit to complete your account setup.", order: 3 })

  const activationSteps: IStep[] = [
        {
            'icon': SuccessIconWithClass,
            'text': 'Tell about yourself'
        },
        {
          icon: () => <ArrowIcon />
        },
        { 
            'icon': (props.activeMenu === 2|| props.activeMenu === 3 ) ? SuccessIconWithClass : Warning,
            'text': 'Add Co-Owner'
        },
        {
          icon: () => <ArrowIcon  />
        },
        {
            'icon': props.activeMenu === 3 ? SuccessIconWithClass:Warning,
            'text': 'Review & Submit' 
        }
    ]
    const progress = (props.activeMenu===3) ? 60 : (props.activeMenu===2) ? 56 : (props.activeMenu===1) ? 33 : 0;


  /**
   * This method handles the onClick event of the menu items and 
   * calls the goBackClick function passed as a prop with the appropriate action 
   * to navigate between the screens
   * @param action 
   */
  const handleMenuClick = (action: string) => {
    if (props.goBackClick) {
      if(action==='verify_yourself'){
        props.goBackClick(1);
      }else if(action==='review_and_submit'){
        props.goBackClick(3);
      }else if(action==='add_a_co-owner'){
        props.goBackClick(2);
      }
      
    }

  };
/**
 * Maps each step number to its corresponding form key.
 * This is used for identifying which form's data or validation status 
 * should be referenced or updated based on the current step in the signup flow.
 */
  const formKeyMap: Record<number, string> = {
    1: 'jtIdentificationForm',
    2: 'jtCoOwnerForm',
  };
  return (
  <>
    {!isMobileScreen && !isSmallScreen?
    <Grid id="login-promo-Home-Grid" item xs={12} >
    <FxCard id="login-promo-Home-Card" className="fx-login-promo fx-login-promo-width-and-bg">
      <FxCardHeader className='fx-login-promo-header-card'>
        <Grid container direction="row" justifyContent="space-between" >
          <Grid item xs={10}>
            <Typography id="business-owner-card-left-card-title" className='fx-login-promo-left-sidebar-header' >
              Welcome!
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography id="business-owner-card-left-card-title" className='fx-login-promo-left-sidebar-header' >
              Let's set up your Passport Account
            </Typography>
          </Grid>
        </Grid>
      </FxCardHeader>
      <FxCardBody id="login-promo-Home-Card-Body" >
        <Grid item container xs={12} className='fx-signup-stage'>
          {options.map((link: any, index: any) => {
            const step = link?.order;
            const isPast = props.activeMenu > step;
            const formKey = formKeyMap[step];
            const isFormValid = formKey ? getKey(formKey) === 'valid' : false;
            const showVerified = isPast && isFormValid;
            return (
              <Grid item xs={12}>
                <ul id={'login-promo-icon-' + link.action}  >
                <li className={props.activeMenu === link.order ? 'fx-signup-stage-selected-theme-color' : ''}>
                  <Grid item container alignItems="center" xs={12}>
                    <Grid item>
                      <Badge badgeContent={index + 1} >
                      <Box className='fx-signup-stage-icon'>{checkMenuValid(link, keys[index], props.activeMenu)}</Box>
                      </Badge>
                    </Grid>
                    <Grid item xs={8}>
                        <Typography
                          variant="h4"
                          className="fx-list-item-maintitle"
                          onClick={() => handleMenuClick(link.action)}
                        >
                          {link.title}
                        </Typography>
                      {link.subtitle && (
                        <Typography variant="body2" className="fx-list-item-subtitle">
                          {link.subtitle}
                        </Typography>
                      )}
                    </Grid>
                  <ul>
                    {link.childOptions?.map((childLink: any) => {
                      return <li><Typography variant="h6" className={props.activeMenu === link.order ? 'fx-selected-list' : ''}>{childLink.title}</Typography></li>
                    })}
                  </ul>
                  </Grid>
                </li>

              </ul>
              </Grid>
            )
          })}
        </Grid>
      </FxCardBody>
      <FxCardFooter>
      <Grid xs={12} columnSpacing={2}>
          <div className="left-panel-privacy left-panel-privacy-individual">
                  <ShieldSignupLeftpanel />
                  <p>Your privacy matters to us. Your information is securely stored and encrypted.</p>
                </div>
        </Grid>
      </FxCardFooter>
    </FxCard>
  </Grid>
  :
        <Grid item xs={12} className='fx-stepper fx-kyc-stepper fx-stepper-mob' >
          <FxStepper steps={activationSteps} alternativeLabel={true}  />
        </Grid>
      }
    </>
  )
})